import * as types from 'modules/auth/actionTypes';
import type { LOGIN_STEPS } from 'modules/auth/constant';
import type { SetAuthStepAction, StepData } from 'modules/auth/types';
import { createReducer } from 'utils/ReduxUtils';

type State = Partial<Record<LOGIN_STEPS, StepData>>;

const initialState: State = {};

const setData = (state: State, { payload }: SetAuthStepAction): State => ({
  ...state,
  [payload.step]: payload.data ?? {},
});

const reset = (): State => initialState;

export default createReducer(initialState, {
  [types.SET_AUTH_STEP]: setData,
  [types.SIGN_IN_SUCCESS]: reset,
});
